import {ContentAnnotation} from "../../../../presentation/views/content/helpers";
import {ActionContext} from "vuex";
import {ContentState, getContentProvider, getCurrentContent} from "./content_module";
import {
  AnnotationEvent,
  annotationSubject
} from "../../../../presentation/views/content/menu/ContentAnnotationNotifier";

class AnnotationState {
  annotations: ContentAnnotation[] = [];
}

const state = new AnnotationState();
type AnnotationActionContext = ActionContext<AnnotationState, ContentState>;

const mutations = {
  SET_ANNOTATIONS(state: AnnotationState, annotations: ContentAnnotation[]) {
    state.annotations = annotations;
  },
  SET_ANNOTATION(state: AnnotationState, {index, annotation}: {index: number, annotation: ContentAnnotation}) {
    state.annotations[index] = annotation;
  },
  ADD_ANNOTATION(state: AnnotationState, annotation: ContentAnnotation) {
    state.annotations?.unshift(annotation);
  },
  REMOVE_ANNOTATION(state: AnnotationState, annotationIndex: number) {
    state.annotations.splice(annotationIndex, 1);
  },
};

const actions = {
  async loadAnnotations(ctx: AnnotationActionContext) {
    try {
      const provider = getContentProvider(ctx);
      const content = getCurrentContent(ctx);
      const annotations = await provider.getAllContentAnnotations(content.id) ?? [];
      ctx.commit("SET_ANNOTATIONS", annotations);
    } catch (e) {
      console.error("[loadAnnotations] Error ", e);
      throw e;
    }
  },

  async takingNotes(ctx: AnnotationActionContext, annotation: ContentAnnotation) {
    try {
      annotationSubject.notify(AnnotationEvent.TAKING_NOTES, annotation);
    } catch (e) {
      console.error("[takingNotes] Error ", e);
      throw e;
    }
  },

  async createAnnotation(ctx: AnnotationActionContext, annotation: ContentAnnotation) {
    try {
      const provider = getContentProvider(ctx);
      const content = getCurrentContent(ctx);
      const newContentAnnotation = await provider.createContentAnnotation(content.id, annotation);
      let annotations = ctx.state.annotations;
      annotations = [newContentAnnotation, ...annotations];
      ctx.commit("SET_ANNOTATIONS", annotations);
      annotationSubject.notify(AnnotationEvent.NOTE_CREATED, annotation);
    } catch (e) {
      console.error("[createAnnotation] Error ", e);
      throw e;
    }
  },

  async updateAnnotation(ctx: AnnotationActionContext, {index, text}: {index: number, text: string}) {
    try {
      const provider = getContentProvider(ctx);
      const content = getCurrentContent(ctx);

      const annotations = ctx.state.annotations;
      const annotation = annotations[index];
      annotation.text = text;

      annotations[index] = await provider.updateContentAnnotation(content.id, annotation);
      ctx.commit("SET_ANNOTATIONS", annotations);
      annotationSubject.notify(AnnotationEvent.NOTE_UPDATED, annotation);
    } catch (e) {
      console.error("[updateAnnotation] Error ", e);
      throw e;
    }
  },

  async selectAnnotation(ctx: AnnotationActionContext, index: number) {
    try {
      const annotation = ctx.state.annotations[index];
      annotationSubject.notify(AnnotationEvent.NOTE_SELECTED, annotation);
    } catch (e) {
      console.error("[selectAnnotation] Error ", e);
      throw e;
    }
  },

  async deleteAnnotation(ctx: AnnotationActionContext, index) {
    try {
      const provider = getContentProvider(ctx);
      const content = getCurrentContent(ctx);
      const annotation = ctx.state.annotations[index];
      await provider.deleteContentAnnotation(content.id, annotation.id);
      ctx.commit("REMOVE_ANNOTATION", index);
      annotationSubject.notify(AnnotationEvent.NOTE_DELETED, annotation);
    } catch (e) {
      console.error("[deleteAnnotation] Error ", e);
      throw e;
    }
  },
};

const getters = {
  annotations: (state: AnnotationState) => state.annotations ?? [],
};

const modules = {}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
  modules,
};